<script setup></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="207" height="145" viewBox="0 0 207 145" fill="none">
    <g clip-path="url(#clip0_6686_47084)">
      <path d="M207 0H0V145H207V0Z" fill="white" />
      <path
        d="M151.386 57V43.3207L110.139 1.99316H34.9258V94.4932"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M151.386 119.5V142.993H34.9258V93.7432"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-dasharray="6 6"
      />
      <path d="M151 44H109V2" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M53.1567 59.0352H116.239"
        stroke="currentColor"
        stroke-width="3.04348"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M53.1567 29.6445H79.8455"
        stroke="currentColor"
        stroke-width="3.04348"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M53.1567 44.7383H79.8455"
        stroke="currentColor"
        stroke-width="3.04348"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M53.1567 72.6191H117.772"
        stroke="currentColor"
        stroke-width="3.04348"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M53.1567 87.6191H117.772"
        stroke="currentColor"
        stroke-width="3.04348"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M53.1567 101.619H117.772"
        stroke="currentColor"
        stroke-width="3.04348"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M53.1567 115.619H117.772"
        stroke="currentColor"
        stroke-width="3.04348"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M168 71V83H140V71" stroke="#FF531A" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M160 71V77" stroke="#FF531A" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M140 113V98H177V113" stroke="#FF531A" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M182 119H138C136.674 119 135.402 118.473 134.464 117.536C133.527 116.598 133 115.326 133 114V70C133 68.6739 133.527 67.4021 134.464 66.4645C135.402 65.5268 136.674 65 138 65H173L187 79V114C187 115.326 186.473 116.598 185.536 117.536C184.598 118.473 183.326 119 182 119Z"
        stroke="#FF531A"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6686_47084">
        <rect width="207" height="145" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
